import apiHelpers from '@/utils/api'
import { AlqIdentityToken } from '@/models/query/AlqIdentityToken'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloIdentityToken } from '@/models/alo/AloIdentityToken'
import { AxiosPromise, AxiosResponse } from 'axios'
import { AlqForgottenPass } from '@/models/query/AlqForgottenPass'
import { TemplateMail } from '@/enum/TemplateMail'

export default {
  authenticate(user:AlqIdentityToken):AxiosPromise<AlrContainer<AloIdentityToken>>  {
    return apiHelpers.apiCall({ 
        url:'api/auth/identityToken', 
        method:'POST', 
        data: user,
        transformResponse: [function (data:string) {                              
          return new AlrContainer<AloIdentityToken>(JSON.parse(data),AloIdentityToken.createReadOnlyAloIndentityToken)
        }]
     })
  },
  
  getAuthenticatedUser():AxiosPromise<AlrContainer<AloIdentityToken>>  {
    return apiHelpers.apiCall({ 
      url: 'api/auth/renewToken', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloIdentityToken>(JSON.parse(data),AloIdentityToken.createReadOnlyAloIndentityToken)      
      }] 
    })
  },
 
  forgetPassword(data:AlqForgottenPass): AxiosPromise<AlrContainer<string>>  {   
    data.mtpId = TemplateMail.ForgotPassword
    return apiHelpers.apiCall({ 
      url: '/api/password/forgotten', 
      method: 'POST',
      data,
      transformResponse: [function (data: string) {          
        return JSON.parse(data) as AlrContainer<string>
      }] 
    })
  },

  changePassword(userId:number,oldPassword:string,newPassword:string):AxiosPromise<AlrContainer<any>>  {
    return apiHelpers.apiCall({ 
      url: `api/password/user/${userId}`, 
      method: 'PUT',
      data: {oldPassword,newPassword}
    })
  },

  createPassword(data:AlqForgottenPass): AxiosPromise<AlrContainer<AloIdentityToken>>  {
    data.mtpId = TemplateMail.ChangePassword
    return apiHelpers.apiCall({ 
      url: '/api/password/forgotten', 
      method: 'PUT',
      data,
      transformResponse: [function (data:string) {                              
        return new AlrContainer<AloIdentityToken>(JSON.parse(data),AloIdentityToken.createReadOnlyAloIndentityToken)
      }]
    })
  }
}